import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import ConfirmButton from "@saleor/components/ConfirmButton";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    cancelButton: {
      backgroundColor: "#F4F4F4",
      color: theme.palette.text.primary,
      height: 39,
      textTransform: "none",
      width: 136
    },
    closeButton: {
      color: theme.palette.text.secondary,
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    },

    confirmButton: {
      "& span": {
        color: "#ffffff"
      },
      "&.outlined": {
        "&:hover": {
          backgroundColor: "#ffffff"
        },
        backgroundColor: "#ffffff",
        border: "2px solid #0030FF"
      },
      "&.outlined span": {
        color: "#0030FF !important"
      },
      "&:hover": {
        backgroundColor: "#0030FF"
      },
      "&:hover span": {
        color: "#ffffff"
      },
      "&:last-child": {
        marginLeft: "10px"
      },

      backgroundColor: "#0030FF",
      color: "#ffffff",
      height: 39,

      textTransform: "none",
      width: 136
    },
    content: {
      color: theme.palette.text.secondary,
      fontSize: "14px",
      padding: theme.spacing(1)
    },
    dialogPaper: {
      backgroundColor: "white",
      borderRadius: 8,
      overflow: "hidden",
      position: "relative",
      textAlign: "center",
      width: 468
    },
    title: {
      fontSize: "20px",
      fontWeight: 700,
      marginBottom: theme.spacing(1)
    }
  }),
  { name: "MfaBackModalCard" }
);

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onLeave: () => void;
  onGotIt: () => void;
  isMfaProcessed: boolean; // Add this prop
}

const MfaBackModalCard: React.FC<CustomDialogProps> = props => {
  const { open, onClose, onConfirm, onGotIt, onLeave, isMfaProcessed } = props;
  const classes = useStyles(props);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
    >
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>

      <DialogTitle disableTypography>
        <Typography className={classes.title}>
          {isMfaProcessed
            ? "Authentication in Progress"
            : "You are about to leave this page"}
        </Typography>
      </DialogTitle>

      <Typography className={classes.content}>
        {isMfaProcessed
          ? "Aborting this process may cause authentication issues"
          : "If you leave this page, this authentication method will have a cooldown before you can use it again."}
      </Typography>

      <DialogActions>
        {isMfaProcessed ? (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <ConfirmButton
              transitionState="default"
              color="secondary"
              variant="contained"
              type="submit"
              className={classes.confirmButton}
              onClick={onGotIt}
            >
              Got it
            </ConfirmButton>
          </div>
        ) : (
          <>
            <Button
              onClick={onLeave}
              className={classes.cancelButton}
              style={{ color: "red" }}
              color="inherit"
              variant="text"
            >
              Leave
            </Button>
            <ConfirmButton
              transitionState="default"
              color="secondary"
              variant="contained"
              type="submit"
              className={classes.confirmButton}
              onClick={onConfirm}
            >
              Stay
            </ConfirmButton>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MfaBackModalCard;
